import { useState } from "react";
import { Icone } from "@/components/Icone";
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from "@/components/ui/input-group";

/** Senha com o olho para mostrar — o botão fica fora do tab, como antes. */
export function CampoSenha(props: Omit<React.ComponentProps<"input">, "type">) {
  const [visivel, setVisivel] = useState(false);
  return (
    <InputGroup className="h-11 rounded-[10px] bg-muted">
      <InputGroupInput type={visivel ? "text" : "password"} {...props} />
      <InputGroupAddon align="inline-end">
        <InputGroupButton
          size="icon-xs"
          tabIndex={-1}
          aria-label={visivel ? "Ocultar senha" : "Mostrar senha"}
          onClick={() => setVisivel((v) => !v)}
        >
          <Icone nome={visivel ? "olho-fechado" : "olho"} className="h-3.5 w-3.5" />
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  );
}
